import { CatalogResourceDc } from "@evergis/api";
import React, { Dispatch, FC, SetStateAction, useCallback, useEffect, useState } from "react";
import { api } from "../../../../evergis/api";
import { useSelectResourcePath } from "../../../../hooks/useDialogs";
import { ClickableIcon, PathInput } from "./styled";

export type PathFieldProps = {
  width?: string;
  resource?: Partial<CatalogResourceDc>;
  value: CatalogResourceDc[];
  onChange: Dispatch<SetStateAction<CatalogResourceDc[]>>;
};

export const PathField: FC<PathFieldProps> = ({ width, resource, value = [], onChange }) => {
  const initialPathString = value.length > 0 ? value.map(({ name }) => name).join("/") : resource?.path;
  const [pathString, setPathString] = useState(initialPathString);
  const openSaveResourceInDirectory = useSelectResourcePath();
  const onChangePath = useCallback(async () => {
    let path = [];

    if (resource?.resourceId) {
      try {
        path = await api.catalog.getParents(resource?.resourceId);
      } catch (e) {
        path = [];
      }
    }

    openSaveResourceInDirectory([""], { path: value.length > 0 ? value : path, onApply: onChange });
  }, [resource, value, onChange, openSaveResourceInDirectory]);

  useEffect(() => {
    if (resource?.resourceId && resource?.path === void 0) {
      (async () => {
        const fullResource = await api.catalog.getResource(resource?.resourceId);

        setPathString(fullResource.path?.replace(fullResource.name, ""));
      })();
    }
  }, [resource?.path, resource?.resourceId]);

  useEffect(() => {
    setPathString(value.map(({ name }) => name).join("/"));
  }, [value]);

  return (
    <PathInput width={width} type={"text"} value={pathString} disabled>
      <ClickableIcon kind={"folder"} disabled={!onChange} onClick={onChangePath} />
    </PathInput>
  );
};
